import React from "react";
import { FC } from "react";
import { makeStyles } from "@material-ui/core";
import useUserQueries from "../../../hooks/useUserQueries";
import { useQuery } from "react-query";
import Loading from "../../../../../components/Loading";
import { mutateErrors } from "../../../../../utils";
import Error from "../../../../../components/Error";
import Container from "@material-ui/core/Container";
import PageHeader from "../../../../../components/PageHeader";
import Grid from "@material-ui/core/Grid";
import UserListItem from "../../../components/admin/UserListItem";
import { QUERY_KEYS } from "../../../../../constants";
import { UserRole } from "../../../enums/UserRole";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
}));

const TeachersPage: FC = () => {
  const classes = useStyles();

  const { fetchAll } = useUserQueries();

  const { adminUsersList } = QUERY_KEYS;

  const { isLoading, isFetching, refetch, isError, error, data } =
    useQuery<any>([adminUsersList, UserRole.Teacher], () =>
      fetchAll(UserRole.Teacher),
    );

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  const users = data.data;

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader title={"Teachers"} subtitle={"Here are listed teachers"} />
      </Container>
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={2}>
          {users.length ? (
            users.map((user: any, index) => (
              <UserListItem
                user={user}
                refetch={refetch}
                key={`TeacherListItem_${index}`}
              />
            ))
          ) : (
            <Error text={"No Teachers Found"} />
          )}
        </Grid>
      </Container>
    </>
  );
};

export default React.memo(TeachersPage);
